import { MDBAnimation, MDBBtn, MDBCard, MDBCardBody, MDBCardHeader, MDBCardText, MDBCardTitle, MDBCol, MDBContainer, MDBRow } from "mdb-react-ui-kit";
import React from "react";

import { VisionMissionValue } from '../../Home/VisionMissionValue/VisionMissionValue'

export function AboutUsContent() {

    return (
        <>
            <MDBContainer className={'border border-0 border-danger p-2 mb-5'}>
                <MDBContainer className={'border border-0 border-success p-2'}>
                    <MDBCard className={'border border-0 border-success shadow'}>
                        <MDBCardHeader>ABOUT US</MDBCardHeader>
                        <MDBCardBody>
                            <MDBRow className={'border border-0 border-danger mb-5 g-4'}>
                                <MDBCol sm={12} lg={5}>
                                    <img src='../../../logo.jpeg' className='img-fluid shadow-4' alt='...' />
                                </MDBCol>
                                <MDBCol sm={12} lg={7}>
                                    <p className={'ps-0 fw-light'}>NUS Network Ghana is a research and development organization established in 2020 with a strong commitment to
                                        promoting Neglected and Underutilized Species (NUS)—also referred to as orphan crops, opportunity crops,
                                        indigenous crops, or traditional crops.
                                    </p>
                                    <p className={'ps-0 fw-light'}>
                                        Our work is driven by a deep passion for agricultural biodiversity and the critical role these crops play in sustainable food systems.
                                    </p>
                                </MDBCol>
                            </MDBRow>
                            <MDBRow className={'border border-0 border-success'}>

                                Our Work and Key Activities
                                <hr className="hr" />
                                <p className={'ps-0 fw-light'}>
                                    At NUS Network Ghana, we implement practical, community-driven initiatives that strengthen the conservation, production, and utilization of Neglected and Underutilized Species (NUS). Our key activities include:
                                </p>

                                <ul className={'border border-0 border-danger ms-2 fw-light'}>
                                    <MDBAnimation start={'onScroll'} animation={'slide-in-up'} delay={1000}>
                                        <li>
                                            In situ and ex situ conservation of NUS crops through community seed banking systems, ensuring the preservation of valuable genetic resources for present and future generations.
                                        </li>
                                    </MDBAnimation>
                                    <MDBAnimation start={'onScroll'} animation={'slide-in-up'} delay={1000}>
                                        <li>
                                            Establishment of School Biodiversity Fun Clubs in both Junior High Schools (JHS) and Senior High Schools (SHS) to inculcate awareness, appreciation, and active promotion of NUS crops among young people.
                                        </li>
                                    </MDBAnimation>
                                    <MDBAnimation start={'onScroll'} animation={'slide-in-up'} delay={1000}>
                                        <li>
                                            Capacity building and training of farmers on sustainable production practices, value addition, and effective marketing of NUS crops to improve livelihoods and enhance food and nutrition security.
                                        </li>
                                    </MDBAnimation>
                                    <MDBAnimation start={'onScroll'} animation={'slide-in-up'} delay={1000}>
                                        <li>
                                            Piloting and implementation of Community Seed Banks in Ghana, providing farmers with reliable access to quality seeds while strengthening local seed systems.
                                        </li>
                                    </MDBAnimation>
                                    <MDBAnimation start={'onScroll'} animation={'slide-in-up'} delay={1000}>
                                        <li>
                                            Multiplication of NUS crop varieties to support conservation efforts, increase availability of planting materials, and promote wider adoption by farming communities.
                                        </li>
                                    </MDBAnimation>
                                </ul>

                            </MDBRow>
                        </MDBCardBody>
                    </MDBCard>
                </MDBContainer>
            </MDBContainer>
            {/* <MDBContainer className={'border border-1 border-danger p-3'}> */}
            {/* </MDBContainer> */}
            <VisionMissionValue />

        </>
    )
}